var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformanceOptimization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9877 28.3154C13.5713 27.4974 12.9233 26.7871 12.0735 26.2964C10.4895 25.3819 8.5946 25.4562 7.11495 26.3239C6.32913 25.4915 5.62643 24.5557 5.02913 23.5211C4.43175 22.4864 3.97254 21.4101 3.64453 20.3133C5.13593 19.4659 6.1478 17.8619 6.1478 16.0328C6.1478 14.2052 5.13769 12.6024 3.64826 11.7543C4.30927 9.53612 5.48173 7.46732 7.11473 5.74157C8.59439 6.60943 10.4895 6.68375 12.0735 5.7692C13.6576 4.85464 14.5408 3.17635 14.529 1.46101C16.8401 0.90969 19.2179 0.927761 21.4694 1.46446C21.4588 3.17867 22.3419 4.85535 23.9249 5.7692C25.5088 6.68375 27.4038 6.60943 28.8834 5.74171C29.6692 6.57414 30.3719 7.50992 30.9692 8.54457C31.5666 9.57922 32.0259 10.6556 32.3538 11.7523C30.8624 12.5998 29.8506 14.2037 29.8506 16.0329C29.8506 17.8604 30.8607 19.4633 32.3501 20.3114C31.689 22.5296 30.5166 24.5983 28.8836 26.3241C27.404 25.4562 25.5089 25.3819 23.9248 26.2964C23.0959 26.7751 22.4589 27.4628 22.0416 28.2556",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6821 9.01855C23.3171 10.0811 25.1768 12.6618 25.1768 15.6772C25.1768 18.1723 23.9034 20.3697 21.9714 21.6558V31.0073C21.9714 33.2044 20.1883 34.9448 17.9996 34.9448C15.8108 34.9448 14.0277 33.2051 14.0277 31.0073V21.6558C12.0956 20.3696 10.8223 18.1723 10.8223 15.6772C10.8223 12.6618 12.682 10.0811 15.317 9.01855V13.6936L17.9996 15.56L20.6821 13.6936V9.01855Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceOptimization);
export default __webpack_public_path__ + "static/media/performance-optimization.a5da81e8b8e1e327ad41c412e692c3f0.svg";
export { ForwardRef as ReactComponent };